export default "__VITE_ASSET__CCDBVYTc__"